module.exports = __webpack_public_path__ + "img/ring_r_l_1_1.cf3f2da4.png";